module.exports = __webpack_public_path__ + "img/2.24b910fc.jpg";